export function loadMoreInit() {
    const loadMoreBtn = document.querySelector(".block-page__load-more-btn");

    console.log(blogAjax.ajaxurl);

    if (loadMoreBtn) {
        loadMoreBtn.addEventListener('click', function () {

            let page = Number(this.dataset.page) + 1;
            let max = Number(this.dataset.max);

            loadMoreBtn.classList.add("site-btn--loading");

            fetch(blogAjax.ajaxurl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                body: new URLSearchParams({
                    action: 'load_more_blog',
                    page: page
                })
            })
                .then(response => response.text())
                .then(html => {
                    document.querySelector('.blog-items').insertAdjacentHTML('beforeend', html);

                    this.dataset.page = page;

                    if (page >= max) {
                        this.remove();
                    } else {
                        loadMoreBtn.classList.remove("site-btn--loading");
                    }

                });
        });
    }
}